// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lora:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Didact+Gothic&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   MAIN (HERO) SLIDER STYLES
   ========================= */

.foreground-content {
  width: 100% !important;
  padding-top: 10px;
  position: relative;
  z-index: 2;
}
footer {
  position: relative;
  z-index: 2;
}
.carousel {
  position: relative;
  top: 0;
  z-index: 1;
  height: calc(100vh - 66px);
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  background-color: #000; /* Fallback for images */
  box-sizing: border-box;
}
.carousel .list {
  position: relative;
  height: 100%;
}
.carousel .list .item {
  position: absolute;
  inset: 0;
  opacity: 0;
  z-index: 0;
  transition: opacity 0.8s ease-in-out, z-index 0s 0.8s;
}
.carousel .list .item img {
  position: fixed;
  top: 66px;
  width: 100%;
  height: 120%;
  object-fit: cover;
  object-position: center;
}
.carousel .list .item.active {
  opacity: 1;
  z-index: 1;
  transition: opacity 0.8s ease-in-out, z-index 0s 0s;
}

/* Text Overlay in Main Slider */
.carousel .list .item .content {
  position: absolute;
  top: 30%;
  left: 10%;
  transform: translateX(-50%);
  text-align: left;
  color: #fff;
  width: 60%;
  padding: 10px;
  border-radius: 10px;
  background: rgba(255,255,255,0);
  opacity: 0;
  transform: translateY(50px);
}
.carousel .list .item.active .content {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease-in-out, transform 0.8s ease-in-out;
  position: absolute;
  z-index: 2;
}
.carousel .list .item .content .heading {
  font-size: 2rem;
  font-weight: normal;
  letter-spacing: 4px;
  text-transform: uppercase;
  margin-bottom: 10px;
  /* Use Audrey for headings */
  font-family: 'Audrey', serif;
  color: #562b2b;
  opacity: 0;
  transform: translateX(-50px);
}
.carousel .list .item .content p {
  font-size: 1.5rem;
  font-weight: normal;
  letter-spacing: 4px;
  color: #fff;
  margin-bottom: 0.5rem;
  font-family: 'Raleway', sans-serif;
}
.carousel .list .item.active .content .heading {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 0.8s ease-in-out 0.2s, transform 0.8s ease-in-out 0.2s;
}
.carousel .list .item .content .title {
  font-size: 3.8rem;
  font-weight: bold;
  letter-spacing: 1.6px;
  line-height: 0.7;
  margin-bottom: 7px;
  /* Use Audrey for headings */
  font-family: 'Audrey', serif;
  color: #efefef;
  opacity: 0;
  transform: translateY(50px);
}
.carousel .list .item.active .content .title {
  line-height: 1;
  padding-bottom: 1.5rem;
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease-in-out 0.4s, transform 0.8s ease-in-out 0.4s;
}
.carousel .list .item .content .description {
  font-size: 1.2rem;
  line-height: 1.2;
  margin-bottom: 15px;
  /* Use Lora for descriptions */
  font-family: 'Lora', serif;
  opacity: 0;
  transform: translateX(50px);
}
.carousel .list .item.active .content .description {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 0.8s ease-in-out 0.6s, transform 0.8s ease-in-out 0.6s;
}
.carousel .list .item::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(24deg, hsl(240, 100%, 3%) 4%, rgba(0,1,16,0.914) 17%, rgba(255,255,255,0) 100%);
  pointer-events: none;
  position: fixed;
  top: 66px;
}

/* Thumbnail Section (unchanged) */
.carousel .thumbnail {
  display: none;
  position: absolute;
  bottom: 5%;
  left: 70%;
  transform: translateX(-50%);
  gap: 10px;
  justify-content: center;
  align-items: center;
  width: auto;
  max-width: 100%;
  overflow: hidden;
  z-index: 10;
}
.carousel .thumbnail .item {
  width: 120px;
  height: 180px;
  cursor: pointer;
  border-radius: 5px;
  overflow: hidden;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  flex-shrink: 0;
}
.carousel .thumbnail .item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.carousel .thumbnail .item.active {
  transform: scale(1.1);
  box-shadow: 0 4px 10px rgba(255,255,255,0);
  border: 2px solid transparent;
}

.carousel .arrows {
  position: absolute;
  top: 28%;
  width: 1%;
  left: 10%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transform: translateY(-50%);
  z-index: 10;
}
.carousel .arrows button {
  background: none;
  color: #370808;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  padding: 0 10px;
  line-height: 1;
  transition: color 0.3s ease;
}
.carousel .arrows button:hover {
  color: #f1683a;
}
.carousel .arrows button#prev::before {
  content: '‹';
  font-size: 2.7rem;
  color: #fff;
}
.carousel .arrows button#next::before {
  content: '›';
  font-size: 2.7rem;
  color: #fff;
}

/* Default Owl Carousel arrow styling for sub-sliders */
.owl-prev, .owl-next {
  color: #007bff;
  background-color: transparent;
  border: 1px solid #007bff;
  padding: 10px;
  border-radius: 50%;
  font-size: 1.5rem;
  transition: color 0.3s ease, background-color 0.3s ease;
}
.owl-prev:hover, .owl-next:hover {
  color: #fff;
  background-color: #007bff;
  border-color: #160606;
}

@media (max-width: 768px) {
  .carousel .list .item .content {
    width: 80%;
    left: 7%;
    top: 5%;
  }
  .carousel .list .item .content .title {
    font-size: 2.5rem;
  }
  .carousel .list .item .content .description {
    font-size: 1rem;
  }
  .carousel .thumbnail .item {
    width: 70px;
    height: 70px;
    margin-top: 0;
    margin-bottom: 120px;
  }
  .carousel .arrows button {
    width: 30px;
    height: 30px;
    font-size: 1rem;
    color: #498bd1;
    margin-top: 720px;
  }
}

/* ===========================
   SUBSEQUENT SECTIONS & CARDS
   =========================== */

/* Centered page container */
.page-container.container {
  background-color: #ffffff;
  margin: 2px auto;
  padding: 15px;
  max-width: 1200px;
  box-shadow: none;
  border-radius: 0;
}

/* Main Headings for Sections */
.consultative-events-heading {
  font-family: 'Didact Gothic', sans-serif;
  font-size: 2rem;
  font-weight: bold;
  color: #1c1491;
  text-align: left;
  margin: 10px 10;
  letter-spacing: 1px;
}

/* Two-line clamp with standard property for compatibility */
.two-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Ensure truncated text and the link appear sequentially */
.description-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.description-link {
  display: block;
  margin-top: 4px;
}

/* Common Card: white background, compact, uniform size */
.common-card {
  background-color: #ffffff;
  border-radius: 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  margin-bottom: 0;
  padding: 1px;
  height: 333px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
}

/* Fixed Image in Cards */
.common-card-image {
  width: 100%;
  height: 260px;
  object-fit: cover;
  border-radius: 0;
}

/* Text Container in Cards */
.card-content {
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  flex: 1 1;
  overflow: hidden;
}

/* Card Title: one line, smaller text */
.card-title {
  font-size: 1rem;
  font-weight: bold;
  font-family: 'Didact Gothic', sans-serif;
  color: #142651;
  margin-bottom: 0;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Card Description: two lines, smaller text */
.card-description {
  font-size: 0.75rem;
  color: #333;
  line-height: 1.2;
  margin-bottom: 1px;
  font-family: 'Didact Gothic', sans-serif;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Sub-item Card */
.card-subitem {
  background-color: #ffffff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  border-radius: 0;
  margin-bottom: 0;
  padding: 0;
}

/* "View All" Link */
.view-all-container {
  text-align: right;
  margin-top: 2px;
}
.view-all-link {
  font-size: 12px;
  color: #007bff;
  text-decoration: none;
  font-weight: bold;
}
.view-all-link:hover {
  text-decoration: underline;
}

/* ---------- Separate Slider Margin Settings ---------- */
.examinations-slider {
  margin-top: 16px;
  margin-bottom: 0;
}
.updates-slider {
  margin-top: 16px;
  margin-bottom: 0;
}
.tenders-slider {
  margin-top: 16px;
  margin-bottom: 0;
}
.news-slider {
  margin-top: 16px;
  margin-bottom: 0;
}

/* ---------- Sling Slots Overlay at the Bottom of the Main Slider ---------- */
.sling-slots-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 3;
  display: flex;
  justify-content: center;
}

/* Container aligning the four rectangles */
.sling-slots-container {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 8px;
  background: rgba(11, 20, 68, 0.308);
}

/* Each sling slot takes up 24% */
.sling-slot {
  width: 24%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Category label at the top of each slot */
.sling-slot-category {
  font-size: 0.9rem;
  font-family: 'Didact Gothic', sans-serif;
  color: #fff;
  margin-bottom: 4px;
  text-align: center;
  width: 100%;
}

/* The rectangle that holds the rotating item */
.sling-rectangle {
  width: 100%;
  height: 130px; /* Fixed height for consistency */
  background: rgba(9, 7, 102, 0.192);
  border: 1px solid rgba(44, 44, 56, 0.089);
  border-radius: 0;
  padding: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

/* Title in the rectangle: clamped to one line */
.sling-rectangle-title {
  font-size: 0.85rem;
  font-weight: bold;
  font-family: 'Didact Gothic', sans-serif;
  color: #fff;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
}

/* Description in the rectangle: clamp to three lines */
.sling-rectangle-description {
  font-size: 0.75rem;
  font-family: 'Lora', serif;
  color: #fff;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Ensure that the appended links are fully visible within the sling rectangle */
/* Both vendor-prefixed and standard line-clamp properties are defined */
.sling-rectangle .description-link {
  display: block;
  -webkit-line-clamp: unset;
  line-clamp: unset;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.css"],"names":[],"mappings":"AAKA;;8BAE8B;;AAE9B;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,0BAA0B;EAC1B,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,sBAAsB,EAAE,wBAAwB;EAChD,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,UAAU;EACV,mDAAmD;AACrD;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,gEAAgE;EAChE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,4BAA4B;EAC5B,cAAc;EACd,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,0EAA0E;AAC5E;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,4BAA4B;EAC5B,cAAc;EACd,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,wBAAwB;EACxB,0EAA0E;AAC5E;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,0EAA0E;AAC5E;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2GAA2G;EAC3G,oBAAoB;EACpB,eAAe;EACf,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mEAAmE;EACnE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,eAAe;EACf,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA,uDAAuD;AACvD;EACE,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,uDAAuD;AACzD;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,QAAQ;IACR,OAAO;EACT;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA;;gCAEgC;;AAEhC,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,wCAAwC;EACxC,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,2DAA2D;AAC3D;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,SAAO;EACP,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,iBAAiB;EACjB,wCAAwC;EACxC,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;;AAEA,0DAA0D;AAC1D;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA,2CAA2C;AAC3C;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,mCAAmC;AACrC;;AAEA,iCAAiC;AACjC;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,iBAAiB;EACjB,wCAAwC;EACxC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,aAAa,EAAE,iCAAiC;EAChD,kCAAkC;EAClC,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,gFAAgF;AAChF,wEAAwE;AACxE;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');\n@import url(\"https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap\");\n@import url('https://fonts.googleapis.com/css2?family=Lora:wght@400;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Didact+Gothic&display=swap');\n\n/* =========================\n   MAIN (HERO) SLIDER STYLES\n   ========================= */\n\n.foreground-content {\n  width: 100% !important;\n  padding-top: 10px;\n  position: relative;\n  z-index: 2;\n}\nfooter {\n  position: relative;\n  z-index: 2;\n}\n.carousel {\n  position: relative;\n  top: 0;\n  z-index: 1;\n  height: calc(100vh - 66px);\n  width: 100%;\n  margin: 0 auto;\n  overflow: hidden;\n  background-color: #000; /* Fallback for images */\n  box-sizing: border-box;\n}\n.carousel .list {\n  position: relative;\n  height: 100%;\n}\n.carousel .list .item {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  z-index: 0;\n  transition: opacity 0.8s ease-in-out, z-index 0s 0.8s;\n}\n.carousel .list .item img {\n  position: fixed;\n  top: 66px;\n  width: 100%;\n  height: 120%;\n  object-fit: cover;\n  object-position: center;\n}\n.carousel .list .item.active {\n  opacity: 1;\n  z-index: 1;\n  transition: opacity 0.8s ease-in-out, z-index 0s 0s;\n}\n\n/* Text Overlay in Main Slider */\n.carousel .list .item .content {\n  position: absolute;\n  top: 30%;\n  left: 10%;\n  transform: translateX(-50%);\n  text-align: left;\n  color: #fff;\n  width: 60%;\n  padding: 10px;\n  border-radius: 10px;\n  background: rgba(255,255,255,0);\n  opacity: 0;\n  transform: translateY(50px);\n}\n.carousel .list .item.active .content {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 0.8s ease-in-out, transform 0.8s ease-in-out;\n  position: absolute;\n  z-index: 2;\n}\n.carousel .list .item .content .heading {\n  font-size: 2rem;\n  font-weight: normal;\n  letter-spacing: 4px;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n  /* Use Audrey for headings */\n  font-family: 'Audrey', serif;\n  color: #562b2b;\n  opacity: 0;\n  transform: translateX(-50px);\n}\n.carousel .list .item .content p {\n  font-size: 1.5rem;\n  font-weight: normal;\n  letter-spacing: 4px;\n  color: #fff;\n  margin-bottom: 0.5rem;\n  font-family: 'Raleway', sans-serif;\n}\n.carousel .list .item.active .content .heading {\n  opacity: 1;\n  transform: translateX(0);\n  transition: opacity 0.8s ease-in-out 0.2s, transform 0.8s ease-in-out 0.2s;\n}\n.carousel .list .item .content .title {\n  font-size: 3.8rem;\n  font-weight: bold;\n  letter-spacing: 1.6px;\n  line-height: 0.7;\n  margin-bottom: 7px;\n  /* Use Audrey for headings */\n  font-family: 'Audrey', serif;\n  color: #efefef;\n  opacity: 0;\n  transform: translateY(50px);\n}\n.carousel .list .item.active .content .title {\n  line-height: 1;\n  padding-bottom: 1.5rem;\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 0.8s ease-in-out 0.4s, transform 0.8s ease-in-out 0.4s;\n}\n.carousel .list .item .content .description {\n  font-size: 1.2rem;\n  line-height: 1.2;\n  margin-bottom: 15px;\n  /* Use Lora for descriptions */\n  font-family: 'Lora', serif;\n  opacity: 0;\n  transform: translateX(50px);\n}\n.carousel .list .item.active .content .description {\n  opacity: 1;\n  transform: translateX(0);\n  transition: opacity 0.8s ease-in-out 0.6s, transform 0.8s ease-in-out 0.6s;\n}\n.carousel .list .item::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  background: linear-gradient(24deg, hsl(240, 100%, 3%) 4%, rgba(0,1,16,0.914) 17%, rgba(255,255,255,0) 100%);\n  pointer-events: none;\n  position: fixed;\n  top: 66px;\n}\n\n/* Thumbnail Section (unchanged) */\n.carousel .thumbnail {\n  display: none;\n  position: absolute;\n  bottom: 5%;\n  left: 70%;\n  transform: translateX(-50%);\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  max-width: 100%;\n  overflow: hidden;\n  z-index: 10;\n}\n.carousel .thumbnail .item {\n  width: 120px;\n  height: 180px;\n  cursor: pointer;\n  border-radius: 5px;\n  overflow: hidden;\n  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n  flex-shrink: 0;\n}\n.carousel .thumbnail .item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.carousel .thumbnail .item.active {\n  transform: scale(1.1);\n  box-shadow: 0 4px 10px rgba(255,255,255,0);\n  border: 2px solid transparent;\n}\n\n.carousel .arrows {\n  position: absolute;\n  top: 28%;\n  width: 1%;\n  left: 10%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transform: translateY(-50%);\n  z-index: 10;\n}\n.carousel .arrows button {\n  background: none;\n  color: #370808;\n  border: none;\n  font-size: 2rem;\n  cursor: pointer;\n  padding: 0 10px;\n  line-height: 1;\n  transition: color 0.3s ease;\n}\n.carousel .arrows button:hover {\n  color: #f1683a;\n}\n.carousel .arrows button#prev::before {\n  content: '‹';\n  font-size: 2.7rem;\n  color: #fff;\n}\n.carousel .arrows button#next::before {\n  content: '›';\n  font-size: 2.7rem;\n  color: #fff;\n}\n\n/* Default Owl Carousel arrow styling for sub-sliders */\n.owl-prev, .owl-next {\n  color: #007bff;\n  background-color: transparent;\n  border: 1px solid #007bff;\n  padding: 10px;\n  border-radius: 50%;\n  font-size: 1.5rem;\n  transition: color 0.3s ease, background-color 0.3s ease;\n}\n.owl-prev:hover, .owl-next:hover {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #160606;\n}\n\n@media (max-width: 768px) {\n  .carousel .list .item .content {\n    width: 80%;\n    left: 7%;\n    top: 5%;\n  }\n  .carousel .list .item .content .title {\n    font-size: 2.5rem;\n  }\n  .carousel .list .item .content .description {\n    font-size: 1rem;\n  }\n  .carousel .thumbnail .item {\n    width: 70px;\n    height: 70px;\n    margin-top: 0;\n    margin-bottom: 120px;\n  }\n  .carousel .arrows button {\n    width: 30px;\n    height: 30px;\n    font-size: 1rem;\n    color: #498bd1;\n    margin-top: 720px;\n  }\n}\n\n/* ===========================\n   SUBSEQUENT SECTIONS & CARDS\n   =========================== */\n\n/* Centered page container */\n.page-container.container {\n  background-color: #ffffff;\n  margin: 2px auto;\n  padding: 15px;\n  max-width: 1200px;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n/* Main Headings for Sections */\n.consultative-events-heading {\n  font-family: 'Didact Gothic', sans-serif;\n  font-size: 2rem;\n  font-weight: bold;\n  color: #1c1491;\n  text-align: left;\n  margin: 10px 10;\n  letter-spacing: 1px;\n}\n\n/* Two-line clamp with standard property for compatibility */\n.two-lines {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Ensure truncated text and the link appear sequentially */\n.description-text {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.description-link {\n  display: block;\n  margin-top: 4px;\n}\n\n/* Common Card: white background, compact, uniform size */\n.common-card {\n  background-color: #ffffff;\n  border-radius: 0;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n  margin-bottom: 0;\n  padding: 1px;\n  height: 333px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow: hidden;\n}\n\n/* Fixed Image in Cards */\n.common-card-image {\n  width: 100%;\n  height: 260px;\n  object-fit: cover;\n  border-radius: 0;\n}\n\n/* Text Container in Cards */\n.card-content {\n  display: flex;\n  flex-direction: column;\n  margin-top: 5px;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* Card Title: one line, smaller text */\n.card-title {\n  font-size: 1rem;\n  font-weight: bold;\n  font-family: 'Didact Gothic', sans-serif;\n  color: #142651;\n  margin-bottom: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  line-clamp: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Card Description: two lines, smaller text */\n.card-description {\n  font-size: 0.75rem;\n  color: #333;\n  line-height: 1.2;\n  margin-bottom: 1px;\n  font-family: 'Didact Gothic', sans-serif;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Sub-item Card */\n.card-subitem {\n  background-color: #ffffff;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.05);\n  border-radius: 0;\n  margin-bottom: 0;\n  padding: 0;\n}\n\n/* \"View All\" Link */\n.view-all-container {\n  text-align: right;\n  margin-top: 2px;\n}\n.view-all-link {\n  font-size: 12px;\n  color: #007bff;\n  text-decoration: none;\n  font-weight: bold;\n}\n.view-all-link:hover {\n  text-decoration: underline;\n}\n\n/* ---------- Separate Slider Margin Settings ---------- */\n.examinations-slider {\n  margin-top: 16px;\n  margin-bottom: 0;\n}\n.updates-slider {\n  margin-top: 16px;\n  margin-bottom: 0;\n}\n.tenders-slider {\n  margin-top: 16px;\n  margin-bottom: 0;\n}\n.news-slider {\n  margin-top: 16px;\n  margin-bottom: 0;\n}\n\n/* ---------- Sling Slots Overlay at the Bottom of the Main Slider ---------- */\n.sling-slots-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  z-index: 3;\n  display: flex;\n  justify-content: center;\n}\n\n/* Container aligning the four rectangles */\n.sling-slots-container {\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  padding: 8px;\n  background: rgba(11, 20, 68, 0.308);\n}\n\n/* Each sling slot takes up 24% */\n.sling-slot {\n  width: 24%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Category label at the top of each slot */\n.sling-slot-category {\n  font-size: 0.9rem;\n  font-family: 'Didact Gothic', sans-serif;\n  color: #fff;\n  margin-bottom: 4px;\n  text-align: center;\n  width: 100%;\n}\n\n/* The rectangle that holds the rotating item */\n.sling-rectangle {\n  width: 100%;\n  height: 130px; /* Fixed height for consistency */\n  background: rgba(9, 7, 102, 0.192);\n  border: 1px solid rgba(44, 44, 56, 0.089);\n  border-radius: 0;\n  padding: 8px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n}\n\n/* Title in the rectangle: clamped to one line */\n.sling-rectangle-title {\n  font-size: 0.85rem;\n  font-weight: bold;\n  font-family: 'Didact Gothic', sans-serif;\n  color: #fff;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  line-clamp: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 2px;\n}\n\n/* Description in the rectangle: clamp to three lines */\n.sling-rectangle-description {\n  font-size: 0.75rem;\n  font-family: 'Lora', serif;\n  color: #fff;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  line-clamp: 3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Ensure that the appended links are fully visible within the sling rectangle */\n/* Both vendor-prefixed and standard line-clamp properties are defined */\n.sling-rectangle .description-link {\n  display: block;\n  -webkit-line-clamp: unset;\n  line-clamp: unset;\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
